module.exports = __webpack_public_path__ + "img/home@3x.70fc97f1.png";